import { PageComponent } from "./PageComponent";

export const UserGuide = () => {
  var Page = {};
  Page.page = "User Guide";
  Page.heading = "USER GUIDE";
  Page.introduction = (
    <p>
      Find out more about WES. If you can’t find the information you need, please use the Make an Enquiry page or phone
      1100 13 933 and get help from a Customer Service Representative.
    </p>
  );
  Page.title = "INFORMATION";
  Page.bodyContent = [
    {
      title: "Privacy Statement",
      content: (
        <p>
          wes.com.au respects your privacy. For detailed information about our privacy policy, please click here.
        </p>
      ),
    },
    {
      title: "Protecting your credit card",
      content: (
        <p>
          Our commerce application is built on Microsoft’s Commerce Server. Provided you are using an SSL-enabled (Secure
          Socket Layering) web browser, such as Netscape’s Navigator or Microsoft’s Internet Explorer, you’ll be able to
          conduct end-to-end encrypted transactions without fear of an unauthorized third party obtaining your credit
          card information.
        </p>
      ),
    },
    {
      title: "Disclaimer",
      content: <p>To read our full disclaimer please click here.</p>,
    },
    {
      title: "Copyright",
      content: (
        <p>
          All content, unless noted otherwise, is copyright &copy; 1994-2006 by wes.com.au All rights reserved. For
          detailed copyright information, please click here.
        </p>
      ),
    },
  ];

  return <PageComponent Data={Page} />;
};
